import { AxiosResponse } from "axios";

import { Error403 } from "./Error403";
import { Error404 } from "./Error404";
import { Error500 } from "./Error500";

interface Props {
  status?: AxiosResponse["status"];
}

export function ServerError({ status }: Props) {
  if (status === 403) {
    return <Error403 />;
  }

  if (status === 404) {
    return <Error404 />;
  }

  return <Error500 />;
}
